<template>
  <!-- 我参与的项目详情 -->
  <div class="myProjectDetail" v-if="projectDetail.status==='participation'">
    <!-- <div class="title">
      <router-link to="" @click.native="$router.go(-1)" slot="left">
        <div class="return"><返回</div>
      </router-link>
      <h3>{{projectDetail.project.title}}</h3>
    </div> -->
    <mt-header :title="projectDetail.project.title">
        <mt-button icon="back" slot="left" @click="$router.go(-1)">返回</mt-button>
    </mt-header>
    <div v-if="projectDetail.status === 'projectOffer'" class="letter">
      <p class="letter_title">我申请了这个项目</p>
      <h1>申请信</h1>
      <p class="letter_money">我的报价： ¥<strong>{{projectDetail.projectOffer.price}}</strong>元</p>
      <pre>
        {{projectDetail.projectOffer.content}}
      </pre>
    </div>
    <div class="step">
      <div :class="{ 'classSelect': projectDetail.project.participationstatus==0 || projectDetail.project.participationstatus==1 || projectDetail.project.participationstatus==2 || projectDetail.project.participationstatus==4}"><p><icon name="globe" class="icon"></icon></p> 达成合作并托管资金 <span></span></div><div :class="{ 'classSelect': projectDetail.project.participationstatus==1 || projectDetail.project.participationstatus==2 || projectDetail.project.participationstatus==4}"><span></span> <p><icon name="handshake-o" class="icon"></icon></p> 执行中 <span></span></div><div :class="{ 'classSelect': projectDetail.project.participationstatus==2 || projectDetail.project.participationstatus==4}"><span></span> <p><icon name="hourglass-half" class="icon"></icon></p> 交付待验收 <span></span></div><div :class="{ 'classSelect': projectDetail.project.participationstatus==4}"><span></span> <p><icon name="pencil" class="icon"></icon></p> 待评价 <span></span></div><div :class="{ 'classSelect': projectDetail.project.participationstatus==4}"><span></span> <p><icon name="thumbs-o-up" class="icon"></icon></p> 完成 </div>
    </div>
    <div v-if="projectDetail.status === 'projectRecommend'" class="recommendTitle">推荐给我的项目</div>
    <div v-if="projectDetail.status === 'issue'" class="recommendTitle">我发布了这个项目</div>
    <div v-if="projectDetail.status === 'participation'" class="my_job">
      <span class="name">我正在参与这个项目</span>
      <button v-if="false" type="button" class="sendBtn">发送消息</button>
    </div>
    <div class="content">
      <div class="bg_img" :class="{'zhaomu':projectDetail.project.status==4,'close':projectDetail.project.status==2,'close1':projectDetail.project.status==3,'close2':projectDetail.project.status==5,'jinxing':projectDetail.project.status==7,'over':projectDetail.project.status==8,'hezuo':projectDetail.project.status==6,'pingjia':projectDetail.project.status==9,'shenhe':projectDetail.project.status==1}"></div>
      <h4>{{projectDetail.project.title}}</h4>
      <span class="type">{{projectDetail.project.projectType}}</span>
      <span class="company">{{projectDetail.project.companyName}}</span>
      <p class='time'>{{projectDetail.project.createTime | formatDate}}</p>
      <div class="cycle">
        <div class="money">
          <span>项目预算</span>
          <p>{{projectDetail.project.prePrice}}</p>
        </div>
        <div class="time">
          <span>时间周期</span>
          <p><span>{{projectDetail.project.period}}</span></p>
        </div>
      </div>
      <div class="skills">
        <span v-for='(skillsList,index) in projectDetail.SkillList' :key="index">{{skillsList.name}}</span>
      </div>
      <div class="path">
        <p><icon name="suitcase"></icon> {{projectDetail.project.industry}}</p>
        <p><icon name="map-marker"></icon> {{projectDetail.project.city}}</p>
        <p><icon name="cogs"></icon>
          倾向接单
          <span v-if="projectDetail.project.enterType == 0">
            没有倾向
          </span>
          <span v-if="projectDetail.project.enterType == 1">
            个人
          </span>
          <span v-if="projectDetail.project.enterType == 2">
            团队/工作室
          </span>
        </p>
      </div>
      <div class="describe">
        <p>项目描述</p>
        <pre>{{projectDetail.project.description}}</pre>
      </div>
      <div v-if="projectDetail.photoUrl.length > 0" class="img_describe">
        <p>图片说明</p>
        <img v-for="(imgurl,index) in projectDetail.photoUrl" :key="index" v-lazy="imgurl.fullPath">
      </div>
      <div class="people">
        <div class="recommend">
          <p>已推荐 {{projectDetail.project.countRecommender}} 人</p>
          <div>
            <span v-for="(recommend,index) in recommendList" :key="index">
              <img :src="projectDetail.httpUrl+recommend.photo" v-if="recommend.photo">
              {{recommend.account.name}}
            </span>
          </div>
        </div>
        <div class="apply">
          <p>已申请 {{projectDetail.project.countOffer}} 人</p>
          <div>
            <span v-for="(apply,index) in applyList" :key="index">
              <img :src="projectDetail.httpUrl+apply.photo" v-if="apply.photo">
              {{apply.account.name}}
            </span>
          </div>
        </div>
        <div class="look">
          <p>已浏览 {{projectDetail.project.countVisit}} 人</p>
        </div>
      </div>
    </div>
    <div class="btns">
      <!-- 审核中&招募中 -->
      <div v-if="projectDetail.project.status == 1 || projectDetail.project.status == 4" class="typeOne">
        <span style="border-right:1px solid #ccc;" @click= 'toCloseProject(projectId,projectDetail.project.status)'>关闭项目</span>
        <span @click= 'toModifyProject(projectId)' v-if="projectDetail.project.status == 1">修改项目</span>
        <router-link class="recommendBtn" :to="{path: '/project/recommendPeople', query: {projectId: projectId}}" style="background-color:#1663c9;">推荐的专家</router-link>
        <router-link class="applyBtn" :to="{path: '/project/applyPeople', query: {projectId: projectId}}" style="background-color:#108ee9;">申请的专家</router-link>
      </div>
      <!-- 已合作 -->
      <div v-if="projectDetail.project.status == 6" class="typeTwo">等待开工</div>
      <!-- 进行中 -->
      <!-- <div v-if="projectDetail.project.status == 7" @click= 'finishPeoject(projectId,projectDetail.project)' class="typeThree">确认验收</div> -->
      <!-- 已验收 -->
      <div v-if="projectDetail.project.status == 8" @click= 'toEvaluate()' class="typeThree">给个评价</div>
      <!-- 完成 -->
      <div v-if="projectDetail.project.status == 9 && false" class="typeThree">查看评价</div>
    </div>
  </div>
  <!-- 推荐给我的项目详情 -->
  <div class="myProjectDetail" v-else-if="projectDetail.status==='projectRecommend'">
    <!-- <div class="title">
      <router-link to="" @click.native="$router.go(-1)" slot="left">
        <div class="return"><返回</div>
      </router-link>
      <h3>{{projectDetail.project.title}}</h3>
    </div> -->
    <mt-header :title="projectDetail.project.title">
        <mt-button icon="back" slot="left" @click="$router.go(-1)">返回</mt-button>
    </mt-header>
    <div v-if="projectDetail.status === 'projectRecommend'" class="recommendTitle">推荐给我的项目</div>
    <div v-if="projectDetail.status === 'issue'" class="recommendTitle">我发布了这个项目</div>
    <div v-if="projectDetail.status === 'projectOffer'" class="recommendTitle">我申请了这个项目</div>
    <div v-if="projectDetail.status === 'participation'" class="my_job">
      <span class="name">我正在参与这个项目</span>
      <button v-if="false" type="button" class="sendBtn">发送消息</button>
    </div>
    <div class="content">
      <div class="bg_img" :class="{'zhaomu':projectDetail.project.status==4,'close':projectDetail.project.status==2,'close1':projectDetail.project.status==3,'close2':projectDetail.project.status==5,'jinxing':projectDetail.project.status==7,'over':projectDetail.project.status==8,'hezuo':projectDetail.project.status==6,'pingjia':projectDetail.project.status==9,'shenhe':projectDetail.project.status==1}"></div>
      <h4>{{projectDetail.project.title}}</h4>
      <span class="type">{{projectDetail.project.projectType}}</span>
      <span class="company">{{projectDetail.project.companyName}}</span>
      <p class='time'>{{projectDetail.project.createTime | formatDate}}</p>
      <div class="cycle">
        <div class="money">
          <span>项目预算</span>
          <p>{{projectDetail.project.prePrice}}</p>
        </div>
        <div class="time">
          <span>时间周期</span>
          <p><span>{{projectDetail.project.period}}</span></p>
        </div>
      </div>
      <div class="skills">
        <span v-for='(skillsList,index) in projectDetail.SkillList' :key="index">{{skillsList.name}}</span>
      </div>
      <div class="path">
        <p><icon name="suitcase"></icon> {{projectDetail.project.industry}}</p>
        <p><icon name="map-marker"></icon> {{projectDetail.project.city}}</p>
        <p><icon name="cogs"></icon>
          倾向接单
          <span v-if="projectDetail.project.enterType == 0">
            没有倾向
          </span>
          <span v-if="projectDetail.project.enterType == 1">
            个人
          </span>
          <span v-if="projectDetail.project.enterType == 2">
            团队/工作室
          </span>
        </p>
      </div>
      <div class="describe">
        <p>项目描述</p>
        <pre>{{projectDetail.project.description}}</pre>
      </div>
      <div v-if="projectDetail.photoUrl.length > 0" class="img_describe">
        <p>图片说明</p>
        <img v-for="(imgurl,index) in projectDetail.photoUrl" :key="index" v-lazy="imgurl.fullPath">
      </div>
      <div class="people">
        <div class="recommend">
          <p>已推荐 {{projectDetail.project.countRecommender}} 人</p>
          <div>
            <span v-for="(recommend,index) in recommendList" :key="index">
              <img :src="projectDetail.httpUrl+recommend.photo" v-if="recommend.photo">
              {{recommend.account.name}}
            </span>
          </div>
        </div>
        <div class="apply">
          <p>已申请 {{projectDetail.project.countOffer}} 人</p>
          <div>
            <span v-for="(apply,index) in applyList" :key="index">
              <img :src="projectDetail.httpUrl+apply.photo" v-if="apply.photo">
              {{apply.account.name}}
            </span>
          </div>
        </div>
        <div class="look">
          <p>已浏览 {{projectDetail.project.countVisit}} 人</p>
        </div>
      </div>
    </div>
    <div class="btns">
      <div v-if="projectDetail.project.status==4" class="typeThree" @click="sendApply(projectDetail.project)">发送意向</div>
    </div>
  </div>
  <!-- 我发布的项目详情 -->
  <div class="myProjectDetail" v-else-if="projectDetail.status==='issue'">
    <mt-header :title="projectDetail.project.title">
        <mt-button icon="back" slot="left" @click="$router.go(-1)">返回</mt-button>
    </mt-header>
    <div class="step">
      <div :class="{ 'classSelect': projectDetail.project.pathwaystatus==0 || projectDetail.project.pathwaystatus==1 || projectDetail.project.pathwaystatus==2 || projectDetail.project.pathwaystatus==3 || projectDetail.project.pathwaystatus==4 || projectDetail.project.pathwaystatus==5}">
        <p><icon name="globe" class="icon"></icon></p> 招募中 <span></span></div>
      <div :class="{ 'classSelect': projectDetail.project.pathwaystatus==1 || projectDetail.project.pathwaystatus==2 || projectDetail.project.pathwaystatus==3 || projectDetail.project.pathwaystatus==4 || projectDetail.project.pathwaystatus==5}">
        <span></span> <p><icon name="handshake-o" class="icon"></icon></p> 雇佣并付款 <span></span>
      </div>
      <div :class="{ 'classSelect': projectDetail.project.pathwaystatus==2 || projectDetail.project.pathwaystatus==3 || projectDetail.project.pathwaystatus==4 || projectDetail.project.pathwaystatus==5}">
        <span></span> <p><icon name="hourglass-half" class="icon"></icon></p> 进行中 <span></span>
      </div>
      <div :class="{ 'classSelect': projectDetail.project.pathwaystatus==3 || projectDetail.project.pathwaystatus==4 || projectDetail.project.pathwaystatus==5}">
        <span></span> <p><icon name="shopping-bag" class="icon"></icon></p> 待验收 <span></span>
      </div>
      <div :class="{ 'classSelect': projectDetail.project.pathwaystatus==4 || projectDetail.project.pathwaystatus==5}">
        <span></span> <p><icon name="pencil" class="icon"></icon></p> 待评价 <span></span>
      </div>
      <div :class="{ 'classSelect': projectDetail.project.pathwaystatus==5}">
        <span></span> <p><icon name="thumbs-o-up" class="icon"></icon></p> 完成 
      </div>
    </div>
    <div v-if="projectDetail.project.status == 6 || projectDetail.project.status == 7 || projectDetail.project.status == 8 || projectDetail.project.status == 9" class="talk">
      <img :src="projectDetail.imageUrl">
      <span class="name"><span>{{projectDetail.name}}</span>正在进行项目</span>
      <button v-if="false" type="button" class="sendBtn">发送消息</button>
    </div>
    <div class="content">
    <div class="bg_img" :class="{'zhaomu':projectDetail.project.status==4,'close':projectDetail.project.status==2,'close1':projectDetail.project.status==3,'close2':projectDetail.project.status==5,'jinxing':projectDetail.project.status==7,'over':projectDetail.project.status==8,'hezuo':projectDetail.project.status==6,'pingjia':projectDetail.project.status==9,'shenhe':projectDetail.project.status==1}"></div>
      <h4>{{projectDetail.project.title}}</h4>
      <span class="type">{{projectDetail.project.projectType}}</span>
      <span class="company">{{projectDetail.project.companyName}}</span>
      <p class='time'>{{projectDetail.project.createTime | formatDate}}</p>
      <div class="cycle">
        <div class="money">
          <span>项目预算</span>
          <p>{{projectDetail.project.prePrice}}</p>
        </div>
        <div class="time">
          <span>时间周期</span>
          <p><span>{{projectDetail.project.period}}</span></p>
        </div>
      </div>
      <div class="skills">
        <span v-for='(skillsList,index) in projectDetail.SkillList' :key="index">{{skillsList.name}}</span>
      </div>
      <div class="path">
        <p><icon name="suitcase"></icon> {{projectDetail.project.industry}}</p>
        <p><icon name="map-marker"></icon> {{projectDetail.project.city}}</p>
        <p><icon name="cogs"></icon> 
          倾向接单
          <span v-if="projectDetail.project.enterType == 0">
            没有倾向
          </span>
          <span v-if="projectDetail.project.enterType == 1">
            个人
          </span>
          <span v-if="projectDetail.project.enterType == 2">
            团队/工作室
          </span>
        </p>
      </div>
      <div class="describe">
        <p>项目描述</p>
        <pre>{{projectDetail.project.description}}</pre>
      </div>
      <div v-if="projectDetail.photoUrl.length > 0" class="img_describe">
        <p>图片说明</p>
        <img v-for="(imgurl,index) in projectDetail.photoUrl" :key="index" v-lazy="imgurl.fullPath">
      </div>
      <div class="people">
        <div class="recommend">
          <p>已推荐 {{projectDetail.project.countRecommender}} 人</p>
          <div>
            <span v-for="(recommend,index) in recommendList" :key="index">
              <img :src="projectDetail.httpUrl+recommend.photo" v-if="recommend.photo">
              {{recommend.account.name}}
            </span>
          </div>
        </div>
        <div class="apply">
          <p>已申请 {{projectDetail.project.countOffer}} 人</p>
          <div>
            <span v-for="(apply,index) in applyList" :key="index">
              <img :src="projectDetail.httpUrl+apply.photo" v-if="apply.photo">
              {{apply.account.name}}
            </span>
          </div>
        </div>
        <div class="look">
          <p>已浏览 {{projectDetail.project.countVisit}} 人</p>
        </div>
      </div>
    </div>
    <div class="btns">
      <!-- 审核中&招募中 -->
      <div v-if="projectDetail.project.status == 1 || projectDetail.project.status == 4" class="typeOne">
        <span style="border-right:1px solid #ccc;" @click= 'toCloseProject(projectId,projectDetail.project.status)'>关闭项目</span>
        <span @click= 'toModifyProject(projectId)' v-if="projectDetail.project.status == 1">修改项目</span>
        <router-link class="recommendBtn" :to="{path: '/project/recommendPeople', query: {projectId: projectId}}" style="background-color:#1663c9;">推荐的专家</router-link>
        <router-link class="applyBtn" :to="{path: '/project/applyPeople', query: {projectId: projectId}}" style="background-color:#108ee9;">申请的专家</router-link>
      </div>
      <!-- 已合作 -->
      <div v-if="projectDetail.project.status == 6" class="typeTwo">等待开工</div>
      <!-- 进行中 -->
      <div v-if="projectDetail.project.status == 7" @click= 'finishPeoject(projectId,projectDetail.project)' class="typeThree">确认验收</div>
      <!-- 已验收 -->
      <div v-if="projectDetail.project.status == 8" @click= 'toEvaluate()' class="typeThree">给个评价</div>
      <!-- 完成 -->
      <div v-if="projectDetail.project.status == 9 && false" class="typeThree">查看评价</div>
    </div>
  </div>
  <!-- 我申请的项目详情 -->
  <div class="myProjectDetail" v-else-if="projectDetail.status==='projectOffer'">
    <!-- <div class="title">
      <router-link to="" @click.native="$router.go(-1)" slot="left">
        <div class="return"><返回</div>
      </router-link>
      <h3>{{projectDetail.project.title}}</h3>
    </div> -->
    <mt-header :title="projectDetail.project.title">
        <mt-button icon="back" slot="left" @click="$router.go(-1)">返回</mt-button>
    </mt-header>
    <div class="letter">
      <p class="letter_title">我申请了这个项目</p>
      <h1>申请信</h1>
      <p class="letter_money">我的报价： ¥<strong>{{projectDetail.projectOffer.price}}</strong></p>
      <pre>{{projectDetail.projectOffer.content}}</pre>
    </div>
    <div class="content">
      <div class="bg_img" :class="{'zhaomu':projectDetail.project.status==4,'close':projectDetail.project.status==2,'close1':projectDetail.project.status==3,'close2':projectDetail.project.status==5,'jinxing':projectDetail.project.status==7,'over':projectDetail.project.status==8,'hezuo':projectDetail.project.status==6,'pingjia':projectDetail.project.status==9,'shenhe':projectDetail.project.status==1}"></div>
      <h4>{{projectDetail.project.title}}</h4>
      <span class="type">{{projectDetail.project.projectType}}</span>
      <span class="company">{{projectDetail.project.companyName}}</span>
      <p class='time'>{{projectDetail.project.createTime | formatDate}}</p>
      <div class="cycle">
        <div class="money">
          <span>项目预算</span>
          <p>{{projectDetail.project.prePrice}}</p>
        </div>
        <div class="time">
          <span>时间周期</span>
          <p><span>{{projectDetail.project.period}}</span></p>
        </div>
      </div>
      <div class="skills">
        <span v-for='(skillsList,index) in projectDetail.SkillList' :key="index">{{skillsList.name}}</span>
      </div>
      <div class="path">
        <p><icon name="suitcase"></icon> {{projectDetail.project.industry}}</p>
        <p><icon name="map-marker"></icon> {{projectDetail.project.city}}</p>
        <p><icon name="cogs"></icon>
          倾向接单
          <span v-if="projectDetail.project.enterType == 0">
            没有倾向
          </span>
          <span v-if="projectDetail.project.enterType == 1">
            个人
          </span>
          <span v-if="projectDetail.project.enterType == 2">
            团队/工作室
          </span>
        </p>
      </div>
      <div class="describe">
        <p>项目描述</p>
        <pre>{{projectDetail.project.description}}</pre>
      </div>
      <div v-if="projectDetail.photoUrl.length > 0" class="img_describe">
        <p>图片说明</p>
        <img v-for="(imgurl,index) in projectDetail.photoUrl" :key="index" v-lazy="imgurl.fullPath">
      </div>
      <div class="people">
        <div class="recommend">
          <p>已推荐 {{projectDetail.project.countRecommender}} 人</p>
          <div>
            <span v-for="(recommend,index) in recommendList" :key="index">
              <img :src="projectDetail.httpUrl+recommend.photo" v-if="recommend.photo">
              {{recommend.account.name}}
            </span>
          </div>
        </div>
        <div class="apply">
          <p>已申请 {{projectDetail.project.countOffer}} 人</p>
          <div>
            <span v-for="(apply,index) in applyList" :key="index">
              <img :src="projectDetail.httpUrl+apply.photo" v-if="apply.photo">
              {{apply.account.name}}
            </span>
          </div>
        </div>
        <div class="look">
          <p>已浏览 {{projectDetail.project.countVisit}} 人</p>
        </div>
      </div>
    </div>
    <div class="btns">
      <div class="typeTwo" v-if="projectDetail.project.status==4">项目正在招募中...</div>
    </div>
  </div>
</template>

<script>
import {formatDate} from '../assets/js/date.js'
import { Indicator, MessageBox, Toast } from 'mint-ui'
export default {
  name: 'home',
  data () {
    return {
      project: this.$route.params.project,
      projectId: '',
      projectDetail: '',
      recommendList: '',
      applyList: '',
      supplierid: '',
      loginId:''
    }
  },
  mounted () {
    this.STATE.state.bottomindex='btnFive'
    if (this.$route.params.projectId !== undefined) {
      this.projectId = this.$route.params.projectId
    } else {
      this.projectId = this.STATE.state.myProjectDetailId
    }
    if(this.$route.params.loginId){
      this.loginId = this.$route.params.loginId
    }else{
      this.loginId = this.STATE.state.loginId
    }
    this.getData()
    this.applyExpert()
    this.recommendExpert()
  },
  methods: {
    getData: function () {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      let _this = this
      this.axios.get('url/weiXinMyProjectDetail?projectId=' + this.projectId + '&loginId=' + this.loginId)
      .then(function (res) {
        Indicator.close()
        _this.projectDetail = res.data.data
        _this.supplierid = res.data.data.supplierid
      }).catch(function (response) {
        Indicator.close()
      })
    },
    // 申请专家
    applyExpert: function (projectid) {
      let _this = this
      this.axios.get('url/work/project/weixinapplyExpert?projectId=' + this.projectId + '&rows=' + 10 + '&page=' + 1 + ' ')
      .then(function (res) {
        _this.applyList = res.data.data
      })
    },
    // 推荐专家
    recommendExpert: function (projectid) {
      let _this = this
      this.axios.get('url/work/project/weixinrecommendExpert?projectId=' + this.projectId + '&rows=' + 10 + '&page=' + 1 + ' ')
      .then(function (res) {
        _this.recommendList = res.data.data
      })
    },
    // 关闭项目
    toCloseProject: function (projectid, projectStatus) {
      this.$router.push({path: '/project/myProjectDetail/closePjt', query: {projectId: projectid, projectStatus: projectStatus}})
    },
    // 验收
    finishPeoject: function (project) {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      let _this = this
      this.axios.get('url/fund/operateCharge?projectId=' + this.projectId)
      .then(function (res) {
        Indicator.close()
        _this.communicate(res.data.data)
      }).catch(function (response) {
        Indicator.close()
      })
    },
    communicate: function (payPrice) {
      let _this = this
      MessageBox.confirm('', {
        message: '在您确认验收后，平台会将项目担保金：￥' + payPrice + '元在24小时内支付到专家的账户中',
        title: '请确认项目交付已验收通过',
        confirmButtonText: '确认验收并付款',
        cancelButtonText: '取消'
      }).then(action => {
        if (action === 'confirm') {
          console.log('确认验收并付款')
          this.axios.get('url/fund/fundSuccessHistory?projectId=' + this.projectId + '&supplierId=' + this.supplierid)
          .then(function (res) {
            if(res.data.success){
              _this.getData()
              _this.applyExpert()
              _this.recommendExpert()
            }
          }).catch(function (response) {
            Toast({
              message: '确认失败！',
              position: 'middle',
              duration: 1000
            })
          })
        }
      }).catch(err => {
        if (err === 'cancel') {
          console.log('取消')
        }
      })
    },
    sendApply (project) {
      this.STATE.state.myProjectDetailId = project.id
      this.$router.push({path: '/project/projectApplyPopup', query: { projectid: project.id }})
    },
    toModifyProject (projectId) {
      this.STATE.state.myProjectDetailId = projectId
      this.$router.push({path: '/updateProject', query: { projectId: projectId }})
    },
    toEvaluate () {
      this.STATE.state.myProjectDetailId = this.projectId
      this.$router.push({path: '/project/evaluate', query: { projectid: this.projectId, projecttitle: this.projectDetail.project.title, suppliername: this.projectDetail.name, supplierId: this.projectDetail.supplierid }})
    }
  },
  filters: {
    formatDate (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    }
  }
}
</script>


<style scoped>
.title{
  width:100%;
  line-height:50px;
  background-color:#108ee9;
  padding:0 14px;
  text-align:center;
  overflow:hidden;
  box-sizing:border-box;
}
 .title .return{
     color:#fff;
     float:left;
 }
 .title h3{
      color:#fff;
      display:inline-block;
      width:auto;
      position:absolute;
      right:70px;
      left:70px;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap;
 }
 .step{
   width:100%;
   line-height:50px;
   overflow-x:auto;
   padding:0 10px;
   white-space:nowrap;
   box-sizing:border-box;
 }
 .step div{
   display:inline-block;
 }
 .step div p{
   display:inline-block;
   width:26px;
   line-height:26px;
   -webkit-border-radiu:50%;
   -moz-border-radiu:50%;
   border-radius:50%;
   background-color:#c2c2c2;
   text-align:center;
 }
 .step div p .icon{
   color:#fff;
   width:15px;
   height:15px;
 }
 .step div span{
   display:inline-block;
   width:25px;
   border-top:1px solid #c2c2c2;
   vertical-align:middle;
 }
 .talk,.my_job{
   line-height:40px;
   border-top:1px solid #ccc;
   border-bottom:1px solid #ccc;
   background-color:#f5f5f5;
   padding:0 15px;
 }
 .talk img{
   width:30px;
   height:30px;
   -webkit-border-radiu:50%;
   -moz-border-radiu:50%;
   border-radius:50%;
   vertical-align:middle;
 }
 .talk .name,.my_job .name{
   font-size:12px;
   margin-left:5px;
 }
 .talk .name span{
   color:#8e8e8e;
   margin-right:12px;
 }
 .talk .sendBtn,.my_job .sendBtn{
   color:#fff;
   font-size:12px;
   background-color:#108ee9;
   /* padding:5px 15px; */
   float:right;
   border:none;
   /* margin-top:7px; */
   -webkit-border-radiu:5px;
   -moz-border-radiu:5px;
   border-radius:5px;
 }
 .content{
   padding:15px;
 }
 .content h4{
     font-size:14px;
     color:#727272;
     overflow:hidden;
     text-overflow:ellipsis;
     white-space:nowrap;
 }
 .content .type{
       display:inline-block;
       font-size:12px;
       background-color:#e9fafd;
       color:#108ee9;
       padding:3px 5px;
       -webkit-border-radiu:12px;
       -moz-border-radiu:12px;
       border-radius:12px;
       margin:5px 0;
 }
   .content .company{
     font-size:12px;
     color:#727272;
     margin-left:15px;
   }
   .content .time{
     font-size:12px;
     color:#727272;
   }
 .content .cycle{
     overflow:hidden;
   }
   .cycle .money,.cycle .time{
     float:left;
   }
   .cycle .time{
     margin-left:35px;
   }
   .cycle .money span,.cycle .time span,.cycle .time p{
     color:#727272;
     font-size:12px;
   }
   .cycle .money p{
     font-size:18px;
   }
   .cycle .time p span{
     font-size:18px;
     color:#000;
   }
 .content .skills{
     max-height:60px;
     overflow:hidden;
 }
   .content .skills span{
     display:inline-block;
     font-size:12px;
     padding:3px 5px;
     background-color:#f2f2f2;
     color:#a6a6a6;
     -webkit-border-radiu:5px;
     -moz-border-radiu:5px;
     border-radius:5px;
     margin:3px 10px;
   }
 .content .path{
     margin-top:5px;
 }
   .content .path p{
     font-size:12px;
     color:#727272;
   }
   .content .path p .fa-icon{
     color:#cecece;
     width:10px;
     height:10px;
     margin-right:20px;
   }
 .content .describe{
     margin-top:10px;
 }
   .content .describe p{
     font-size:14px;
     color:#727272;
   }
   .content .describe pre{
     font-size:14px;
     white-space: pre-wrap;
     word-wrap: break-word;
   }
 .content .img_describe{
    margin-top:10px;
 }
 .content .img_describe p{
   font-size:14px;
   color:#727272;
 }
 .content .img_describe img{
   display:block;
   max-width:100%;
   height:auto;
   margin:0 auto;
 }
 .content .people{
   margin-top:17px;
 }
 .people .recommend,.people .apply,.people .look{
   margin-bottom:10px;
   display:table;
   width:100%;
 }
 .people .recommend p,.people .apply p,.people .look p{
   font-size:12px;
   color:#727272;
   vertical-align:middle;
   display:table-cell;
   width:80px;
 }
 .people .recommend div,.people .apply div,.people .look div{
   display:inline-block;
   margin-right:5px;
   vertical-align:middle;
   height:27px;
   overflow:hidden;
 }
 .people .recommend div img,.people .apply div img,.people .look div img{
   width:27px;
   height:27px;
   -webkit-border-radiu:50%;
   -moz-border-radiu:50%;
   border-radius:50%;
   margin:0 10px;
   vertical-align:middle;
 }
 .people .recommend div span,.people .apply div span,.people .look div span{
   display:inline-block;
   font-size:12px;
   color:#727272;
   margin-right:5px;
 }
 .content .bg_img{
     width:44px;
     height:44px;
     float:right;
     margin-right:-15px;
     margin-top:-15px;
     background-size:100% 100%;
   }
   /* .content .zhaomu{
     background-image:url('../assets/img/main_app/state-4.png');
   }
   .content .close{
     background-image:url('../assets/img/main_app/state-5.png');
   }
   .content .jinxing{
     background-image:url('../assets/img/main_app/state-7.png');
   }
   .content .over{
     background-image:url('../assets/img/main_app/state-8.png');
   }
   .content .hezuo{
     background-image:url('../assets/img/main_app/state-6.png');
   }
   .content .pingjia{
     background-image:url('../assets/img/main_app/state-9.png');
   }
  .content .shenhe{
    background-image:url('../assets/img/main_app/state-10.png');
  } */
  .content .zhaomu{
    background-image:url('../assets/img/main_app/state-4.png');
  }
  .content .close{
    background-image:url('../assets/img/main_app/state-5.png');
  }
  .content .close1{
    background-image:url('../assets/img/main_app/state-5.png');
  }
  .content .close2{
    background-image:url('../assets/img/main_app/state-5.png');
  }
  .content .jinxing{
    background-image:url('../assets/img/main_app/state-7.png');
  }
  .content .over{
    background-image:url('../assets/img/main_app/state-8.png');
  }
  .content .hezuo{
    background-image:url('../assets/img/main_app/state-6.png');
  }
  .content .pingjia{
    background-image:url('../assets/img/main_app/state-8.png');
  }
  .content .shenhe{
    background-image:url('../assets/img/main_app/state-10.png');
  }
 .btns{
    margin-bottom:55px;
  }
 .btns .typeOne{
   width:100%;
   height:50px;
   border-top:1px solid #ccc;
   border-bottom:1px solid #ccc;
   display:table;
 }
 .btns .typeOne span{
   width:50px;
   height:50px;
   background-color:#f5f5f5;
   color:#8e8e8e;
   font-size:14px;
   padding: 5px 10px;
   box-sizing:border-box;
   vertical-align:middle;
   display:table-cell;
 }
 .btns .typeOne a{
   display:inline-block;
   width:50%;
   text-align:center;
   line-height:50px;
   color:#fff;
   text-decoration:none;
   font-size:14px;
 }
 .btns .typeTwo{
   width:100%;
   line-height:50px;
   text-align:center;
   color:#fff;
   background-color:#808080;
   font-size:14px;
 }
 .btns .typeThree{
    width:100%;
    line-height:50px;
    text-align:center;
    color:#fff;
    background-color:#108ee9;
    font-size:14px;
  }
    .recommendTitle{
    line-height: 40px;
    padding-left: 15px;
    border-bottom: 1px solid #ccc;
  }
  .letter{
    padding:20px 15px 0;
  }
  .letter_title{
    font-size: 14px;
  }
  .letter h1{
    text-align: center;
    margin: 10px 0;
    font-weight: bold;
  }
  .letter_money{
    font-size: 14px;
    text-align: center;
    margin-bottom: 5px;
  }
  .classSelect{
    color: #01a8fe;
  }
</style>



// WEBPACK FOOTER //
// myProjectDetail.vue?53b4facb